import { render } from "./CalendarEvent.vue?vue&type=template&id=5ccff0ec&scoped=true&ts=true&lang=pug"
import script from "./CalendarEvent.vue?vue&type=script&lang=ts"
export * from "./CalendarEvent.vue?vue&type=script&lang=ts"

import "./CalendarEvent.vue?vue&type=style&index=0&id=5ccff0ec&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ccff0ec"]])

export default __exports__